import { headers, baseUrl } from "../../common/credentials";

const sourcePort = "50003";
const reconPort = "50004";
const etlPort = "50005";
const Port = "3101";

// export const getProcessingLayerListFromServer = () => {
//     let url = baseUrl + Port + "/api/v2/user_modules/api/getdynamicfilteredlist/process_data/customer_mapping/";
//     return ([headers, url]);
// } 

export const getProcessingLayerListFromServer = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/get_processing_layer_list/";
    return ([headers, url]);
} 


export const getProcessingLayerListFromServer1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/get_all_data/Vendor_Reconcilation_System/vendor_master/";
    return ([headers, url]);
} 

export const getProcessingLayerDataFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_processing_layer_data/";
    return ([headers, url]);
} 

export const getProcessingLayerDataReturnFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_processing_layer_data_return/";
    return ([headers, url]);
} 

export const getProcessingLayerDataWithStatusFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_data_with_status/";
    return ([headers, url]);
} 

export const getUpdateMatchRecordsFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_update_matched_records/";
    return ([headers, url]);
} 

export const getUpdateUnMatchRecordsFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_update_unmatched_records/";
    return ([headers, url]);
} 

export const getUpdateDuplicateRecordsFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_update_duplicate_records/";
    return ([headers, url]);
} 

export const getUpdateContraRecordsFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_update_contra_records/";
    return ([headers, url]);
} 

export const getFileUploadListFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_recon_file_list/";
    return ([headers, url]);
} 

export const getBRSReportFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_brs_report_revised/";
    return ([headers, url]);
} 

export const getUpdateGlBalFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_update_gl_balances_revised/";
    return ([headers, url]);
}

export const getUpdateBankBalFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_update_bank_balances_revised/";
    return ([headers, url]);
}

export const getBalanceFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_balances/";
    return ([headers, url]);
}

export const getMonthEndBalanceFromServer = () => {
    let url = baseUrl + reconPort + "/recon/get_month_end_balance/";
    return ([headers, url]);
}

export const getUpdateMonthEndBalanceToServer = () => {
    let url = baseUrl + reconPort + "/recon/get_update_month_end_balance/";
    return ([headers, url]);
}

export const getUpdateEditedBankStatementToServer = () => {
    let url = baseUrl + reconPort + "/recon/get_edit_bank_statement/";
    return ([headers, url]);
}

export const getRunFileFromServer = () => {
    let url = baseUrl + etlPort + "/recon_etl/get_run_etl/";
    return ([headers, url]);
}

// export const Fetchbankinvoicedetails = () => {
//     let url = baseUrl + Port + "/api/v2/user_modules/getbankinvoicedetails/";
//     return ([headers, url]);
// }

export const Fetchbankinvoicedetails = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/getdynamicfilteredlist/account_receivable/internal_statement_3/";
    return ([headers, url]);
}

export const Fetchbankinvoicedetails_1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/getdynamicfilteredlist/Vendor_Reconcilation_System/internal_statement/";
    return ([headers, url]);
}

export const Fetchextdetails = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/getdynamicfilteredlist/account_receivable/ext_bank_2/";
    return ([headers, url]);
}


export const Fetchbankinvoicedetails1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/getdynamicfilteredlist/Vendor_Reconcilation_System/internal_statement/";
    return ([headers, url]);
}

export const Fetchexternaldetails = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/getdynamicfilteredlist/Vendor_Reconcilation_System/Vendor_Statement/";
    return ([headers, url]);
}



export const Fetchmatchedutrdata = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchmatchedinternalstmnt/";
    return ([headers, url]);
}

export const Fetchmatchedutrdata1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchmatcheddataall/";
    return ([headers, url]);
}

export const updatestatusvalue = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/updatestatus/";
    return ([headers, url]);
}

export const allocateupdatestatusvalue = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/allocateupdatestatus/";
    return ([headers, url]);
}

export const updatestatusvalue1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/updatestatus1/";
    return ([headers, url]);
}

export const fetchmonthwisedata1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchmonthwisedata/";
    return ([headers, url]);
}

export const getdonutseriesdata = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchdonutchartdata/";
    return ([headers, url]);
}

export const getdonutseriesdata1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/getdynamicfilteredlist/Vendor_Reconcilation_System/internal_statement/";
    return ([headers, url]);
}

export const getkpidatafin = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/generatefindashboard/";
    return ([headers, url]);
}

export const getkpidata = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/generatekpiinfo/";
    return ([headers, url]);
}

export const getkpidata1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/generatekpiinfo1/";
    return ([headers, url]);
}

export const getkpidata9 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/generatekpiinfo3/";
    return ([headers, url]);
}

export const getvendorcode = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/generatekpiinfo3/";
    return ([headers, url]);
}


export const getkpidatarecon = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/generatekpiinfonew/";
    return ([headers, url]);
}

export const getpaymenthistory = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchpaymenthistory/";
    return ([headers, url]);
}

export const getstatustypeslist = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchstatustypeslist/";
    return ([headers, url]);
}

export const getremarksdata = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchremarkslist/";
    return ([headers, url]);
}

export const getAgingDashboard = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/generateagingdashboard/";
    return ([headers, url]);
}

// export const getmodeldata = () => {
//     let url = baseUrl + Port + "/api/v2/user_modules/fetchagingdataall/";
//     return ([headers, url]);
// }

export const getkpidata3 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchagingdataall/";
    return ([headers, url]);
}

export const getkpidata4 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchupcommingcollections/";
    return ([headers, url]);
}

export const getexceptiondata = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchexceptiontypedata/";
    return ([headers, url]);
}

export const getexceptiondata1 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchdataforcordsdashboard/";
    return ([headers, url]);
}

export const getexceptiondata2 = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchdataforcordsfin/";
    return ([headers, url]);
}

export const getdataforcardsrecon = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchdataforcordsRecon/";
    return ([headers, url]);
}

export const fetchmonthwisedatanew = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchmonthwisedataall/";
    return ([headers, url]);
}


export const getpaymenthistorynew = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/fetchpaymenthistoryall/";
    return ([headers, url]);
}


export const getdashboard1sidement = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/dashboard1sidemenulist/";
    return ([headers, url]);
}